import AncillaryOfferUIModel from './ancillary-offer';

class UpgradeUIModel {
  constructor({
    ancillaryOffer,
    type,
    segmentCode,
    quantity,
    redeemedCP,
    _meta,
  } = {}) {
    this.ancillaryOffer = new AncillaryOfferUIModel(ancillaryOffer);
    this.type = type;
    this.quantity = quantity;
    this.segmentCode = segmentCode;
    this.redeemedCP = redeemedCP;
    this._meta = _meta;
  }

  toApi(legCode) {
    return {
      '_meta':{
        'class':'UpgradeAncillary',
      },
      'ancillaryOffer': this.ancillaryOffer.toApi(legCode, this.quantity),
      'segmentCode': this.segmentCode,
      'type': this.type,
      'quantity': this.quantity,
    };
  }
}

export default UpgradeUIModel;
